import React, { ComponentProps } from 'react';
import cx from 'classnames';
import { PropsWithClassName } from '@/types/common';
import Asset from '@/components/Common/Asset';
import * as styles from './SampleSelector.module.scss';

export type SampleOption = {
  code: string | null;
  name: string;
  image: ComponentProps<typeof Asset>['asset'];
};

type Props<T extends SampleOption> = PropsWithClassName<{
  shouldShowCode?: boolean;
  options: T[];
  selectedOption?: T;
  onChange: (option: T) => void;
  isCompact?: boolean;
}>;

const SampleSelector = <T extends SampleOption>({
  className,
  options,
  selectedOption,
  onChange,
  shouldShowCode = true,
  isCompact = false,
}: Props<T>) => (
  <div
    className={cx(
      styles.main,
      {
        [styles.compact]: isCompact,
      },
      className
    )}
    role="menu"
  >
    {options.map((option, index) => (
      <div
        key={index}
        role="option"
        onClick={() => onChange(option)}
        aria-selected={selectedOption === option}
      >
        <div className={styles.sample}>
          <Asset asset={option?.image} className={styles.image} />
          <div>
            <span className={styles.name}>{option?.name}</span>
            {shouldShowCode ? <span className={styles.code}>{option?.code}</span> : null}
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default SampleSelector;
